import { SCREEN_WIDTHS } from "../constants/screen_widths";

function getWindowWidth() {
	return window.innerWidth;
}
export function isMobile() {
	return getWindowWidth() <= SCREEN_WIDTHS.XS;
}
export function isTablet() {
	return getWindowWidth() <= SCREEN_WIDTHS.SM && getWindowWidth() > SCREEN_WIDTHS.XS;
}
export function isDesktop() {
	return getWindowWidth() > SCREEN_WIDTHS.SM;
}
export function isDesktopRange() {
	return getWindowWidth() < SCREEN_WIDTHS.MD || isDesktop();
}

export function isContentMax() {
	return getWindowWidth() >= SCREEN_WIDTHS.LG;
}
